import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { KpiValueCard } from "@/components/shared/KpiValueCard";
import type { ExecKpiFamily } from "@/types/executive";

interface ExecKpiFamilyCardProps {
  family: ExecKpiFamily;
  orgSlug: string;
}

export function ExecKpiFamilyCard({ family, orgSlug }: ExecKpiFamilyCardProps) {
  const { t } = useTranslation();

  return (
    <div className="rounded-lg border bg-card p-4 space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-base font-semibold">{family.label}</h3>
        <Link
          to={`/${orgSlug}/${family.drilldown.route}`}
          className="text-xs font-medium text-primary hover:underline"
        >
          {t(family.drilldown.labelKey)}
        </Link>
      </div>
      <div className="grid grid-cols-2 gap-3">
        {family.cards.map((kpi) => (
          <KpiValueCard key={kpi.id} kpi={kpi} />
        ))}
      </div>
    </div>
  );
}
